import { render, staticRenderFns } from "./CurrencyPayment.vue?vue&type=template&id=4d68af26"
import script from "./CurrencyPayment.vue?vue&type=script&lang=js"
export * from "./CurrencyPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports